import stringReplacer from './string';
export default function (flag, mods, value) {
    var result = '';
    var as16BitHex = function (input) {
        var hex = '';
        var len = input.length;
        for (var i = 0; i < len; i++) {
            hex += ('000' + input.charCodeAt(i).toString(16)).slice(-4);
        }
        return hex;
    };
    switch (typeof value) {
        case 'number':
            result = value.toString(16);
            break;
        case 'string':
            result = as16BitHex(value);
            break;
        default:
            result = as16BitHex(JSON.stringify(value));
    }
    return stringReplacer(flag === 'X' ? 'S' : 's', mods, result);
}
